module.exports = __webpack_public_path__ + "media/images/cart/recalc-e0fe2dfdeae3917f358115a2b0aa33ca.gif";